import { useContext, useEffect, useState } from "react";
import { Button, Spin, Input, message } from "antd";
import { webAPIs } from "../config/webAPIs";
import { AuthContext } from "../AuthContext";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../config/axiosInstance";
const { TextArea } = Input;

const ViewTranscript = () => {
  const [audioFiles, setAudioFiles] = useState([]);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const { user, loggedIn, selectedProjectId } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (loggedIn) {
      handleAudioFiles();
    }
  }, [loggedIn, user, selectedProjectId]);

  const handleAudioFiles = async () => {
    if (user && selectedProjectId) {
      try {
        setLoading(true);
        const response = await axiosInstance.get(`${webAPIs.getAudioFiles}?projectId=${selectedProjectId}`);
        if (response.data.success) {
          setAudioFiles(response.data.data);
          setText('')
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  // Download transcript as .txt file
  const handleDownload = (audio) => {
    if (!audio.text) {
      message.warning("Transcript is empty!");
      return;
    }
    // Sanitize file name (remove illegal characters)
    const safeFileName = audio.fileName;
    const blob = new Blob([audio.text], { type: "text/plain" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = safeFileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  return (
    <>
      {loading ? (
        <Spin />
      ) : (
        <div className="w-full sm:h-full sm:p-5 p-2 sm:pl-20 flex flex-col gap-5 ">
          <span className="sm:text-xl font-medium text-center">
            Here you can view the transcripts of your audio files
          </span>
          <div className="flex sm:flex-row flex-col sm:py-5 sm:gap-5 gap-2">
            <div className="sm:w-1/2 w-full">
              {audioFiles.map((audio, id) => (
                <div className="flex gap-5" key={id}>
                  <Input readOnly className="flex-1" value={audio.fileName} />
                  <Button
                    className="bg-sidebarColor text-white"
                    onClick={() => {
                      setText(audio.text);
                    }}
                  >
                    View
                  </Button>
                  <Button
                    className="bg-green-600 text-white"
                    onClick={() => handleDownload(audio)}
                  >
                    Download
                  </Button>
                </div>
              ))}
            </div>
            <div className="sm:w-1/2 w-full">
              <TextArea cols={50} rows={20} value={text} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewTranscript;
